import React from 'react';
import { motion } from 'framer-motion';
import { PhoneFrame } from './PhoneFrame';
import { screens } from '../data/screens';
const points = [{
  title: 'Name it whatever you like',
  body: 'Weekend away 🍻😎, Ski Trip, House bills. If the group calls it something, so does the kitty.'
}, {
  title: 'Pick the currency once',
  body: 'Each kitty runs in a single currency, so every expense in it lines up.'
}, {
  title: 'Add people who aren’t here yet',
  body: 'Add someone by name before they join. Their share is tracked from the start and they can claim it later.'
}];
export function CreateKitty() {
  return <section id="how-it-works" className="relative overflow-hidden bg-[#FFFBF2] py-20 lg:py-28" data-id="element-49" data-mp="23g9beabw0rls">
      <div className="mx-auto max-w-7xl px-6 sm:px-8" data-id="element-50" data-mp="27huyeoi4ym9p">
        <div className="grid items-center gap-14 lg:grid-cols-2 lg:gap-20" data-id="element-51" data-mp="1o4ml7poqafa">
          {/* Copy first on desktop */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-80px'
        }} transition={{
          duration: 0.5
        }} data-id="element-52" data-mp="5o55b4jth7s5">
            <p className="mb-4 text-sm font-black uppercase tracking-widest text-kitty-yellow-700" data-id="element-53" data-mp="1kjfdfjlavekq">
              Step one
            </p>
            <h2 className="mb-5 text-3xl font-black leading-[1.1] tracking-tight text-kitty-dark md:text-4xl lg:text-5xl" data-id="element-54" data-mp="1uat73aqklk5y">
              One trip. One pot.
              <br data-id="element-55" data-mp="16nl5b2scot8o" />
              Everyone included.
            </h2>
            <p className="mb-9 max-w-md text-lg leading-relaxed text-gray-600" data-id="element-56" data-mp="11np6rj2f9u0i">
              Create a kitty, choose the currency and add everyone who's coming.
            </p>

            <ul className="space-y-6" data-id="element-57" data-mp="1bkbqu5mxch1h">
              {points.map(point => <li key={point.title} className="border-l-4 border-kitty-yellow pl-5" data-id="element-58" data-mp="2rybr5hpom8p9">
                  <h3 className="mb-1 text-lg font-extrabold text-kitty-dark" data-id="element-59" data-mp="2mzqn177b74vj">
                    {point.title}
                  </h3>
                  <p className="text-base leading-relaxed text-gray-600" data-id="element-60" data-mp="2u1x0h37yj076">
                    {point.body}
                  </p>
                </li>)}
            </ul>
          </motion.div>

          {/* Screen, angled */}
          <motion.div initial={{
          opacity: 0,
          y: 28
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.55,
          ease: [0.22, 1, 0.36, 1]
        }} className="relative mx-auto w-full max-w-[330px] lg:max-w-[360px]" data-id="element-61" data-mp="33z1lgzq2gpme">
            <div aria-hidden="true" className="absolute -inset-6 -rotate-3 rounded-[3rem] bg-kitty-yellow/25" data-id="element-62" data-mp="2lawms6o9nuug" />
            <PhoneFrame screen={screens.createKitty} shadow="xl" className="relative rotate-[3deg]" data-id="element-63" data-mp="2q2wlxwwiijpz" />
          </motion.div>
        </div>
      </div>
    </section>;
}